import React from 'react';
import Task from "../../../../model2/task/task";
import {FieldViewReferenceProps} from "../../../render/view-reference";
import FieldView from "../../../render/view";
import Reminder from "../../../../model2/reminder/reminer";

export default function FieldReminder_ViewReference(props:FieldViewReferenceProps) {

    const reminder = _.get(props.model, props.field.fieldId, null) as Reminder

    if (!reminder) return null

    const onClick = ()=>{
        gd.navigation.goToReminder(reminder.id)
    }

    // max-w-300

    return (
        <div className={Classes("ui5-control-button-36",props.className)} onClick={onClick}>
            <div className="i5-notification"></div>
            <div className="ui5-txt-default">{reminder.title}</div>
        </div>
    );
}


